export const setDocuments = ({ commit }, payload) => {
  commit('SET_DOCUMENTS', payload)
}
export const addDocuments = ({ commit }, payload) => {
  commit('ADD_DOCUMENTS', payload)
}
export const setDocumentsLoading = ({ commit }, payload) => {
  commit('SET_DOCUMENTS_LOADING', payload)
}

export const setDocumentsByClient = ({ commit }, payload) => {
  commit('SET_DOCUMENTS_BY_CLIENT', payload)
}
export const setDocumentsByClientLoading = ({ commit }, payload) => {
  commit('SET_DOCUMENTS_BY_CLIENT_LOADING', payload)
}
export const clearDocumentsByClient = ({ commit }, payload) => {
  commit('CLEAR_DOCUMENTS_BY_CLIENT', payload)
}
export const clearAllDocumentsByClient = ({ commit }) => {
  commit('CLEAR_ALL_DOCUMENTS_BY_CLIENT')
}

export const setTemplates = ({ commit }, payload) => {
  commit('SET_TEMPLATES', payload)
}
export const addTemplates = ({ commit }, payload) => {
  commit('ADD_TEMPLATES', payload)
}
export const setTemplatesLoading = ({ commit }, payload) => {
  commit('SET_TEMPLATES_LOADING', payload)
}

export const setSigners = ({ commit }, payload) => {
  commit('SET_SIGNERS', payload)
}
export const addSigners = ({ commit }, payload) => {
  commit('ADD_SIGNERS', payload)
}
export const setSignersLoading = ({ commit }, payload) => {
  commit('SET_SIGNERS_LOADING', payload)
}

export const setVariables = ({ commit }, payload) => {
  commit('SET_VARIABLES', payload)
}
export const setVariablesLoading = ({ commit }, payload) => {
  commit('SET_VARIABLES_LOADING', payload)
}

export const setRoles = ({ commit }, payload) => {
  commit('SET_ROLES', payload)
}
export const setRolesLoading = ({ commit }, payload) => {
  commit('SET_ROLES_LOADING', payload)
}

export const setSystemVariables = ({ commit }, payload) => {
  commit('SET_SYSTEM_VARIABLES', payload)
}
export const setSystemVariablesLoading = ({ commit }, payload) => {
  commit('SET_SYSTEM_VARIABLES_LOADING', payload)
}

export const setVariablesOptions = ({ commit }, payload) => {
  commit('SET_VARIABLES_OPTIONS', payload)
}
export const setVariablesOptionsLoading = ({ commit }, payload) => {
  commit('SET_VARIABLES_OPTIONS_LOADING', payload)
}
